import React from 'react';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="chi-footer">
      <div className="container">
        <div className="row g-5">
          {/* Brand Column */}
          <div className="col-lg-4 col-md-6">
            <div className="chi-footer__brand">
              <img src="/logo.png" alt="C.H.I Logistics" />
            </div>
            <p className="chi-footer__tagline">
              Reliable freight solutions across all 48 contiguous states.
              Based in Fresno, CA — trusted nationwide.
            </p>
          </div>

          {/* Quick Links */}
          <div className="col-lg-2 col-md-6 col-6">
            <p className="chi-footer__heading">Navigation</p>
            <nav>
              <a href="#about" className="chi-footer__link d-block">About Us</a>
              <a href="#services" className="chi-footer__link d-block">Services</a>
              <a href="#contact" className="chi-footer__link d-block">Contact</a>
              <a href="/apply" className="chi-footer__link d-block">Drive For C.H.I.</a>
            </nav>
          </div>

          {/* Services List */}
          <div className="col-lg-2 col-md-6 col-6">
            <p className="chi-footer__heading">Services</p>
            <p className="chi-footer__link" style={{ cursor: 'default' }}>Expedited Shipping</p>
            <p className="chi-footer__link" style={{ cursor: 'default' }}>24/7 Dispatch</p>
            <p className="chi-footer__link" style={{ cursor: 'default' }}>Dedicated Lanes</p>
            <p className="chi-footer__link" style={{ cursor: 'default' }}>OTR Transport</p>
          </div>

          {/* Contact Info */}
          <div className="col-lg-4 col-md-6">
            <p className="chi-footer__heading">Contact</p>
            <a
              href="https://www.google.com/maps/place/4616+S+Cedar+Ave,+Fresno,+CA+93725"
              target="_blank"
              rel="noopener noreferrer"
              className="chi-footer__link"
            >
              <FaMapMarkerAlt className="footer-icon" />
              4616 S Cedar Ave, Fresno, CA 93725
            </a>
            <a href="tel:+15594971301" className="chi-footer__link">
              <FaPhoneAlt className="footer-icon" />
              (559) 497-1301
            </a>
            <a href="mailto:safety@chilogistic.com" className="chi-footer__link">
              <FaEnvelope className="footer-icon" />
              safety@chilogistic.com
            </a>
          </div>
        </div>

        <hr className="chi-footer__divider" />

        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-2">
          <p className="chi-footer__copyright">
            &copy; {new Date().getFullYear()} C.H.I Logistics, Inc. All rights reserved.
          </p>
          <p className="chi-footer__copyright">
            Fresno, CA &nbsp;·&nbsp; Serving all 48 states
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
